// extracted by mini-css-extract-plugin
module.exports = {"Continue":"Continue_Continue__26U6F","Confirm":"Continue_Confirm__2f7kl","Cancel":"Continue_Cancel__2wLqQ"};